import type { OpenAPI } from "simplydo/interfaces";

export const userIsConnectedTo = (
  user:
    | Pick<OpenAPI.GET<"/users/me">["response"], "enabledServices">
    | null
    | undefined,
  service: NonNullable<
    OpenAPI.GET<"/users/me">["response"]["enabledServices"]
  >[number],
) => {
  return user && (user.enabledServices || []).indexOf(service) > -1;
};
